import { parseTargetDate, countRemainingWorkdaysInclusive } from '../utils/date';
import { unitLabel } from '../utils/czech';
import type { CountdownMode } from './types';

const DEFAULT_SNACKS_END_DATE = '2026-06-25';

export const COUNTDOWN_MODES: CountdownMode[] = [
    {
        id: 'standard',
        label: 'Standard',
        getTiles: (snapshot) => [
            { key: 'weeks', value: snapshot.parts.weeks, label: unitLabel(snapshot.parts.weeks, 'week') },
            { key: 'days', value: snapshot.parts.days, label: unitLabel(snapshot.parts.days, 'day') },
            { key: 'hours', value: snapshot.parts.hours, label: unitLabel(snapshot.parts.hours, 'hour') },
            { key: 'minutes', value: snapshot.parts.minutes, label: unitLabel(snapshot.parts.minutes, 'minute') },
        ],
    },
    {
        id: 'workdays',
        label: 'Pracovní dny',
        getTiles: (snapshot) => [
            { key: 'workdays', value: snapshot.workdays, label: unitLabel(snapshot.workdays, 'workday') },
        ],
    },
    {
        id: 'totals',
        label: 'Celkem',
        getTiles: (snapshot) => [
            { key: 'weeksTotal', value: snapshot.totalWeeks, label: `celkem ${unitLabel(snapshot.totalWeeks, 'week')}` },
            { key: 'daysTotal', value: snapshot.totalDays, label: `celkem ${unitLabel(snapshot.totalDays, 'day')}` },
            { key: 'hoursTotal', value: snapshot.totalHours, label: `celkem ${unitLabel(snapshot.totalHours, 'hour')}` },
            { key: 'minutesTotal', value: snapshot.totalMinutes, label: `celkem ${unitLabel(snapshot.totalMinutes, 'minute')}` },
        ],
    },
    {
        id: 'snacks',
        label: 'Svačiny',
        getTiles: (snapshot) => {
            const endDateRaw = process.env.REACT_APP_SNACKS_END_DATE || DEFAULT_SNACKS_END_DATE;
            const snacksEndDate = parseTargetDate(endDateRaw, DEFAULT_SNACKS_END_DATE);
            const remaining = countRemainingWorkdaysInclusive(snacksEndDate, snapshot.now);
            return [{ key: 'snacks', value: remaining, label: `${unitLabel(remaining, 'snack')} pro děti` }];
        },
    },
];
